import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { FacebookService } from "src/app/services/social/facebook.service";

@Component({
  selector: "app-facebook-reply",
  templateUrl: "./facebook-reply.component.html",
  styleUrls: ["./facebook-reply.component.css"],
})
export class FacebookReplyComponent implements OnInit {
  loading: boolean = false;

  post: any = {};
  replyBody: string = "";

  constructor(
    private facebookService: FacebookService,
    private toast: ToastrService
  ) {}

  ngOnInit() {
    this.facebookService.postToReply.subscribe((post: object) => {
      if (!Object.keys(post).length) return;

      this.post = post;
      this.openReplyModal();
    });
  }

  openReplyModal() {
    document.getElementById("facebookReplyModalBtn").click();
  }

  replyComment() {
    const commentData = this.post.facebookObject;
    const data = {
      commentId: commentData.comment_id,
      org_id: this.post.orgId,
      message: this.replyBody,
    };

    this.loading = true;
    this.facebookService.replyComment(data).subscribe(
      (response) => {
        this.loading = false;
        const { status_code, success, payload } = response;
        if (
          success &&
          (status_code == 200 || status_code == 201) &&
          payload.id
        ) {
          this.toast.success(`Comment replied successfully.`);
          this.closeReplyModal();
          this.replyBody = "";
          //window.location.reload();
        } else {
          this.toast.error(`Could not reply to comment`);
        }
      },
      (e) => {
        this.replyBody = "";
        this.loading = false;
        this.toast.error(`Could not reply to comment`);
      }
    );
  }

  replyPost() {
    const replyData = this.post.facebookObject;
    const data = {
      postId: replyData.post_id,
      org_id: this.post.orgId,
      message: this.replyBody,
    };

    this.loading = true;
    this.facebookService.replyPost(data).subscribe(
      (response) => {
        this.loading = false;
        const { status_code, success, payload } = response;
        if (
          success &&
          (status_code == 200 || status_code == 201)
        ) {
          this.toast.success(`Post replied successfully.`);
          this.closeReplyModal();
          this.replyBody = "";
          window.location.reload();
        } else {
          this.toast.error(`Could not reply to post`);
        }
      },
      (e) => {
        console.log(e)
        this.replyBody = "";
        this.loading = false;
        this.toast.error(`Could not reply to post`);
      }
    );
  }

  closeReplyModal() {
    document.getElementById("facebookReplyModalBtnClose").click();
  }
}
